/**************************************************
 * Nombre:       Tarjeta_Cliente
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Avatar, Grid2, Typography} from "@mui/material";

const Tarjeta_Cliente = ({item, click}) => {

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            onClick={() => click(item)}
            sx={{p: 1, boxShadow: 2, borderRadius: 2, border: '0.5px solid #EAEAEA', cursor: 'pointer'}}
        >


            <Grid2 container size={{xs: 2}}>
                <Avatar src={item.img}/>
            </Grid2>

            <Grid2 container size={{xs: 10}}>
                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontWeight: 600}}>{item.nombre}</Typography>
                </Grid2>
                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 12}}>{item.ciudad}</Typography>
                </Grid2>
            </Grid2>

        </Grid2>
    )

}
export default Tarjeta_Cliente